var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('subPartnerLink',{attrs:{"subPartners":_vm.subPartners,"partners":_vm.partners},on:{"getSubPartners":_vm.getSubPartners}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }